exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-customer-sign-up-review-approve .registration-info{padding-right:20px}#modal-customer-sign-up-review-approve .existing-matches{border-left:1px solid #ccc;padding-left:20px}#modal-customer-sign-up-review-approve .right-matches{text-align:right}#modal-customer-sign-up-review-approve .customer-linked{color:red}", ""]);

// exports
